import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Controller } from '../models/controller';
import { LibService } from './libService';

@Injectable({
  providedIn: 'root'
})
export class ControllerService {

  baseApi = environment.rootApiFoundation + 'controllers';

  constructor(public libService: LibService) { }

  getController(id: string) {
    return this.libService.getData<any>(this.baseApi, `/${id.toString()}`);
  }

  getAllControllers(): Observable<Controller[]> {
    return this.libService.getData<any>(this.baseApi, '');
  }
}
